import React from 'react'

export default function IconsDocumentDownload({ color = '#463DFB', className = 'icons-icon', style = {} }) {
    return (
        <svg
            className={className}
            style={style}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.99992 18.3334C4.55789 18.3334 4.13397 18.1578 3.82141 17.8453C3.50885 17.5327 3.33325 17.1088 3.33325 16.6668V3.33342C3.33325 2.89139 3.50885 2.46747 3.82141 2.15491C4.13397 1.84235 4.55789 1.66675 4.99992 1.66675H11.6666C11.9304 1.66632 12.1917 1.71809 12.4354 1.81906C12.6791 1.92003 12.9004 2.06822 13.0866 2.25508L16.0766 5.24508C16.264 5.43134 16.4126 5.65287 16.5138 5.89689C16.6151 6.1409 16.667 6.40256 16.6666 6.66675V16.6668C16.6666 17.1088 16.491 17.5327 16.1784 17.8453C15.8659 18.1578 15.4419 18.3334 14.9999 18.3334H4.99992Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.6667 1.66675V5.83341C11.6667 6.05443 11.7545 6.26639 11.9107 6.42267C12.067 6.57895 12.279 6.66675 12.5 6.66675H16.6667M10 15.0001V10.0001M12.5 12.5001L10 15.0001L7.5 12.5001'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
